'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.yearAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/yearAfter.js
// module id = 757
// module chunks = 0